// AboutUs.jsx
import React from 'react';

// import aboutus1 from '../../assets/images/aboutus_2.JPG';

const AboutUs = () => {
  return (
    <section id="about-us" className="bg-white p-8 max-w-6xl mx-auto mt-8 pt-16" >
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-6 font-serif tracking-wide uppercase" style={{ fontFamily: 'Hatton, serif' }}>
        Concept
      </h2>
      <p className="text-center text-xl italic text-pink-500 mb-8 font-serif">
        "Love begins with knowing"
      </p>
      <div className="text-lg text-gray-700 leading-relaxed space-y-6" style={{ fontFamily: 'mincho, serif' }}>
        <p className='text-center leading-4 text-xs'>
          私たちは プロフィールブックや<br /><br />
          前撮り撮影を通じて<br /><br />
          新郎新婦のおふたりがどんな方なのかを<br /><br />
          お互いの大切なゲストに知っていただく<br /><br />
          お手伝いをしています<br /><br />
          おふたりのこれまでの人生や想い出を大切に<br /><br />
          おふたりらしさを<br /><br />
          より反映したものをお届けし<br /><br />
          最高の1日を創るお手伝いをしたいと<br /><br />
          考えています<br /><br />
          結婚式が単なる形式ではなく<br /><br />
          感謝や愛情を伝える場となるよう<br /><br />
          心を込めてサポートします
        </p>
      </div>
      {/* <div className="mt-10 text-center">
        <img
          src={aboutus1}
          alt="About Us"
          className="mx-auto rounded-lg shadow-md w-1/2"
        />
      </div> */}
    </section>
  );
};

export default AboutUs;
